import { compose, replace } from 'ramda';

export const reformatHTMLForDeletedText = (html: string) =>
  compose(replace('<del>', '<s>'), replace('</del>', '</s>'))(html);
